export default __webpack_public_path__ + "static/media/uiux2.94093801.jpeg";